import * as React from "react";

function SvgKlaviyo(props, ref) {
  return (
    <svg
      viewBox="0 0 204.8 138.1"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <linearGradient
        id="klaviyo_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={395.203}
        y1={1218.45}
        x2={395.203}
        y2={1023.11}
        gradientTransform="translate(-177.035 -723.441) scale(.7071)"
      >
        <stop offset={0} stopColor="#efc119" />
        <stop offset={0.331} stopColor="#92c84e" />
        <stop offset={0.486} stopColor="#71bf5b" />
        <stop offset={0.751} stopColor="#15b158" />
        <stop offset={0.903} stopColor="#23ac69" />
        <stop offset={1} stopColor="#23ac69" />
      </linearGradient>
      <path
        d="M4.2 62.5L96 1.7c4-2.3 8.9-2.3 12.9 0l91.8 60.8c3.6 1.8 5.2 6.1 3.4 9.8-.7 1.5-1.9 2.7-3.4 3.4l-12.3 8.1C158.3 36.3 95.5 22.2 48 52.2 35.3 60.3 24.5 71 16.4 83.8L4 75.7C.4 73.8-1 69.4.8 65.8c.8-1.4 2-2.6 3.4-3.3zm98.1-.7c-26.3.1-50.8 13.6-64.8 35.9l21.1 14c14.5-24.1 45.8-31.8 69.8-17.3 7.1 4.3 13 10.2 17.3 17.3l21.1-14c-13.8-22.4-38.2-36-64.5-35.9zm0 50.8c-9.3.1-17.8 5.1-22.4 13.2l14.2 9.3c2.3 2 5.2 3 8.2 3s6-1.1 8.2-3l14.2-9.3c-4.5-8.2-13.1-13.2-22.4-13.2z"
        fill="url(#klaviyo_svg__a)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgKlaviyo);
